import React from "react";
import { TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";

const styles = makeStyles({
  textfield: {
    fontFamily: "inter_600",
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D3DAE3",
      borderRadius: "6px",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D3DAE3",
    },
    "& .MuiOutlinedInput-input": {
      color: "#626b7e",
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "#626b7e",
    },
    // imput value
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "#1D2029",
    },
    "& .MuiInputLabel-outlined": {
      color: "#626b7e",
    },
    //onselect label
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "#ABB4BD",
    },
    // on select border
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff4848",
      borderWidth: "0.1rem",
    },
  },
  textfieldIsSubDomain: {
    // background:"#D3DAE312",
    fontFamily: "inter_600",
    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D3DAE3",
      borderRadius: "6px",
    },
    "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
      borderColor: "#D3DAE3",
    },
    "& .MuiOutlinedInput-input": {
      color: "#626b7e",
      width: "67%",
      "@media (max-width: 1024px)": {
        width: "50%",
      },
    },
    "&:hover .MuiOutlinedInput-input": {
      color: "#626b7e",
    },
    // imput value
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
      color: "#1D2029",
    },
    "& .MuiInputLabel-outlined": {
      color: "#626b7e",
    },
    //onselect label
    "& .MuiInputLabel-outlined.Mui-focused": {
      color: "#ABB4BD",
    },
    // on select border
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#ff4848",
      borderWidth: "0.1rem",
    },
  },
});

const CustomTextField = ({ ...props }) => {
  const classes = styles();

  return (
    <TextField
      {...props}
      className={
        props.isSubDomain ? classes.textfieldIsSubDomain : classes.textfield
      }
      InputProps={{ style: { fontSize: "clamp(12px, 0.729vw, 30px)" } }}
      InputLabelProps={{ style: { fontSize: "clamp(12px, 0.729vw, 30px)" } }}
    />
  );
};

export default CustomTextField;
